<!-- Start Row Columns Area -->
<div class="firefly brook-row-column-area clearfix">
    <div class="aaa creative-gradient--1 ptb--150">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="call-to-action callto-action--1">
                        <div class="content">
                            <h6>Complementa tu formación</h6>
                            <h3><span>¿</span>Estás listo para <span>Comenzar ?</span></h3>
                            <a href="/neuroakashico"><button><span>Ver todos los cursos</span><i class="fa fa-arrow-right"></i></button></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End Row Columns Area -->
